<template>
  <v-app v-if="isLanguageLoaded">
    <v-snackbar v-model="snackbarHomeInfo.isActif" class="snackbarinfo" :top="snackbarHomeInfo.isTop"  color="primary"  :timeout="snackbarHomeInfo.timeout">
      <div class="snackbarinfo-content">
        <span class="icon-attention-info"></span>  <span class="snackbarinfo-text">{{ snackbarHomeInfo.text }}</span>
      </div>
    </v-snackbar>
    <v-snackbar v-model="snackbar.show"   :color="snackbar.color"  :timeout="snackbar.timeout">
        {{ snackbar.text }}
        <v-btn  dark  flat  @click="snackbar.show = false">  Close  </v-btn>
    </v-snackbar>
    <template v-if="isAuthenticated">
      <SidebarMenu/>
      <v-content class="homecontent">
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
        <FirstTimeLoginPopup/>
      </v-content>
    </template>
    <template v-else>
      <v-layout row>
         <v-flex xs3 md4>
           <Logo/>
         </v-flex>
         <v-flex xs6 md4 style="z-index:100">
            <router-view />
         </v-flex>
         <v-flex xs3 md4>
           <BackgroundImage/>
         </v-flex>
      </v-layout>
      <TermsOfServicePopup/>
    </template>
  </v-app>
</template>

<script>
import SidebarMenu from './components/menu/Menu'
import Logo from './components/login/Logo'
import BackgroundImage from './components/login/BackgroundImage'
import FirstTimeLoginPopup from './components/login/FirstTimeLoginPopup'
import TermsOfServicePopup from './components/login/TermsOfServicePopup'
import { mapState } from 'vuex'
import authService from '@/services/Auth'

export default {
  name: 'App',
  components: {
    SidebarMenu,
    Logo,
    BackgroundImage,
    FirstTimeLoginPopup,
    TermsOfServicePopup
  },
  data () {
    return {
      isLanguageLoaded: false,
      snackbarHomeInfo: {
        isActif: `${process.env.VUE_APP_NODE_ENV_API}`.toUpperCase() !== 'prod'.toUpperCase(),
        text: this.$t('InsuranceAPI.NotInProd.NOT_IN_PROD_WARNING', { environment: `${process.env.VUE_APP_NODE_ENV_API}` }),
        timeout: 0,
        isTop: true
      }
    }
  },
  async created () {
    if (this.isAuthenticated) {
      await authService.setLanguage()
    }
    this.isLanguageLoaded = true
  },
  computed: {
    ...mapState('global', ['snackbar']),
    isAuthenticated: function () {
      return this.$store.getters['userdetails/isAuthenticated']
    }
  }
}
</script>
<style>

@import 'css/media.css';
@import 'css/main.css';
@import 'css/table.css';
@import 'css/icons.css';

.homecontent {
  margin-left: 242px;
  padding: 3px 0px 0px !important;
}

#app {
  font-family: 'AllianzNeo', Helvetica, Arial, serif;
  background-color: rgba(254, 255, 254, 1.0)
}
</style>
